import React, { FunctionComponent, useEffect, useState } from 'react';
import { TradeIn } from '@upstart/harmony/lib/legos/dealTypes';
import { MessageType } from '@upstart/harmony/lib/legos/websiteTypes';
import { ErrorMap, TradeInField, TradeInsTableRow } from './TradeInsTableRow';
import KbbService from '../../../services/KbbService';
import { PageMessage } from '../../GlobalUI';

interface TradeInListProps {
  dealerId: string;
  tradeIns: TradeIn[];
  fields: TradeInField[];
  setTradeIns?: (trade: TradeIn[]) => void;
  updatedTradeIns: TradeIn[];
  setUpdatedTradeIns: (trade: TradeIn[]) => void;
  setIsLoading: (state: boolean) => void;
  validationErrors: ErrorMap;
  canEditTradeIns?: boolean;
  canDeleteTradeIns?: boolean;
}
export const TradeInList: FunctionComponent<TradeInListProps> = props => {
  const {
    dealerId,
    tradeIns,
    setTradeIns,
    updatedTradeIns,
    setUpdatedTradeIns,
    setIsLoading,
    validationErrors,
    canEditTradeIns,
    canDeleteTradeIns,
    fields,
  } = props;
  const [years, setYears] = useState<string[]>([]);

  useEffect(() => {
    const fetchYears = async () => {
      try {
        setIsLoading(true);
        setYears((await KbbService.getYears()).map(p => p.name));
        setIsLoading(false);
      } catch (err) {
        setIsLoading(false);
        PageMessage({
          type: MessageType.ERROR,
          message: 'Unable to fetch data from server',
          headline: 'Error',
        });
      }
    };
    fetchYears().catch(() => {});
  }, []);

  const updateRow = (updatedTradeIn: TradeIn, index: number) => {
    setUpdatedTradeIns(
      updatedTradeIns.map((tradeIn, ndx) =>
        ndx === index ? updatedTradeIn : tradeIn,
      ),
    );
  };

  const deleteRow = (index: number) => {
    const filteredList = updatedTradeIns
      .filter((tradeIn, ndx) => ndx !== index)
      .map(tradeIn => ({ ...tradeIn }));
    setTradeIns?.(filteredList);
    setUpdatedTradeIns(filteredList);
  };

  return (
    <div className="listContainer">
      {tradeIns.map((tradeIn, index) => (
        <TradeInsTableRow
          tradeIn={tradeIn}
          index={index}
          fields={fields}
          years={years}
          dealerId={dealerId}
          onSave={updateRow}
          onDelete={deleteRow}
          setIsLoading={setIsLoading}
          validationError={validationErrors[index]}
          canEditTradeIns={canEditTradeIns}
          canDeleteTradeIns={canDeleteTradeIns}
        />
      ))}
      {tradeIns.length === 0 && (
        <div className="noRowsContainer">No Trade-Ins</div>
      )}
    </div>
  );
};
